import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import 'bootswatch/dist/cosmo/bootstrap.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
//import VeeValidation for frontend form validations before submit
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate, {
  // This is the default
  inject: true,
  // Important to name this something other than 'fields'
  fieldsBagName: 'veeFields',
  // This is not required but avoids possible naming conflicts
  errorBagName: 'veeErrors'
});
 
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
Vue.use(VueFormWizard);
 
import App from "./App.vue";

import router from "./router";

import store from "./store";

//import vue toaster for toasted messages
import Toasted from 'vue-toasted';

import _ from 'lodash';

//import vue moment for datetime formatting
import VueMoment from 'vue-moment';

//import vcalendar
import VCalendar from 'v-calendar';
import 'v-calendar/lib/v-calendar.min.css';

//import Datepicker
import DatePicker from 'vue2-datepicker'
Vue.use(DatePicker);

//import PortalVue
import PortalVue from 'portal-vue';
Vue.use(PortalVue);

//import i18n for localization
import i18n from './i18n'

//import Vue Apexcharts
import VueApexCharts from 'vue-apexcharts';
Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts);

//import vue fullscreen
import fullscreen from 'vue-fullscreen'
//Axios import
import axios from 'axios';
//window.axios.defaults.headers.common['Authorization'] = 'application/x-www-form-urlencoded';
Vue.prototype.$axios = axios.create({
  baseURL: '/api'
});
 
Vue.prototype.$axios.defaults.headers.common['Authorization'] = localStorage.getItem('id_token');
 
Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(VCalendar, {
  firstDayOfWeek: 2,
});
Vue.use(Toasted, {
  position: 'bottom-center',
  duration: 2000,
  fullWidth: true,
});

Vue.use(fullscreen);
Vue.use(VueMoment);
 
if(Vue.config.env==="prod"){
    VueMoment.suppressDeprecationWarnings = true;
    i18n.silentTranslationWarn = true;
  }
 
Vue.toasted.register('success', (payload) => {
  if(! payload.message) {
    return "Error"
  }
  return payload.message;
},{
  type : 'success',
  duration: 3000,
  className: ['success-toast',]
});
 
Vue.toasted.register('err', (payload) => {
  if(! payload.message) {
    return "Error"
  }
  return "Error: " + payload.message;
},{
  type : 'error',
  duration: 5000,
  className: ['err-toast',]
});
 
//Import components
 
import AppNav from '@/components/AppNav';
Vue.component('app-nav', AppNav);
 
import SideNav from '@/components/Sidebar';
Vue.component('sidebar-nav', SideNav);
 
//import EventsTable (user made component)
import EventsTable from './components/EventsTable';
Vue.component('events-table', EventsTable);
 
 
Vue.prototype.$axios.interceptors.response.use((response) => {
  return response;
}, function (error) {
  if (error.response.status === 401) {
    Vm.$store.dispatch('logout');
    Vm.$router.push('/auth/login');
    localStorage.clear();
 
  }
  else if (error.response.status === 403){
    Vm.$router.push('/403');
  }
  else if(error.response.status === 500){
    Vm.$toasted.global.err({
      message : i18n.t('conn.err')
    });
  }
  return Promise.reject(error.response);
});
 
router.beforeEach((to, from, next) => {
  let token = localStorage.getItem('id_token');
  if(to.meta.requiresAuth && !token){
    router.push('/auth/login')
  } else next();
});
 
 
var Vm = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");